import { render, staticRenderFns } from "./SNPSwapList.vue?vue&type=template&id=06bab332&scoped=true&"
import script from "./SNPSwapList.vue?vue&type=script&lang=js&"
export * from "./SNPSwapList.vue?vue&type=script&lang=js&"
import style0 from "./SNPSwapList.vue?vue&type=style&index=0&id=06bab332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bab332",
  null
  
)

export default component.exports